const URL = 'https://checkout.razorpay.com/v1/checkout.js';
let loading;
let active = false;
let activeControl;
export const showRazorpayCheckout = () => activeControl?.show();
export const closeRazorpayCheckout = () => activeControl?.cancel();
export const validGatewayOrder = order => Boolean(order && typeof order.key === 'string' && order.key.trim() && typeof order.orderId === 'string' && order.orderId.trim() && Number.isSafeInteger(order.amount) && order.amount > 0 && order.currency === 'INR');
export function loadRazorpayCheckout() {
    if (typeof window === 'undefined')
        return Promise.reject(new Error('Payments require a browser.'));
    if (window.Razorpay)
        return Promise.resolve();
    if (!loading)
        loading = new Promise((resolve, reject) => {
            let script = document.querySelector(`script[src="${URL}"]`);
            const timer = setTimeout(() => finish(new Error('Payment gateway timed out.')), 15000);
            function finish(error) { clearTimeout(timer); if (error || !window.Razorpay) {
                loading = null;
                script?.remove();
                reject(error || new Error('Payment gateway unavailable.'));
            }
            else
                resolve(); }
            if (!script) {
                script = document.createElement('script');
                script.src = URL;
                script.async = true;
                document.body.appendChild(script);
            }
            script.addEventListener('load', () => finish(), { once: true });
            script.addEventListener('error', () => finish(new Error('Payment gateway failed to load.')), { once: true });
        });
    return loading;
}
export async function openRazorpayCheckout({ order, name = 'Redgaady', description, prefill, onReady }) {
    if (!validGatewayOrder(order))
        throw new Error('Payment order is unavailable. Check payment status.');
    if (active)
        throw new Error('A payment window is already open.');
    active = true;
    try {
        await loadRazorpayCheckout();
        return await new Promise((resolve, reject) => {
            const checkout = new window.Razorpay({ key: order.key, order_id: order.orderId, amount: order.amount, currency: order.currency, name, description, prefill,
                // Let Razorpay display all payment methods enabled for the merchant.
                handler: response => response?.razorpay_payment_id && response?.razorpay_signature ? resolve(response) : reject(new Error('Payment proof unavailable. Check payment status.')),
                modal: { ondismiss: () => reject(new Error('Payment window closed. Check the existing payment before trying again.')) } });
            checkout.on('payment.failed', response => { checkout.close?.(); reject(new Error(response?.error?.description || 'Gateway could not confirm payment.')); });
            activeControl = {
                show: () => checkout.open(),
                cancel: () => { checkout.close?.(); reject(new Error('Payment window closed. Check the existing payment before trying again.')); }
            };
            checkout.open();
            onReady?.();
        });
    }
    finally {
        active = false;
        activeControl = null;
    }
}
